// extracted by mini-css-extract-plugin
export default {"container":"NewGanttChart_container__ph0+8","tooltipContainer":"NewGanttChart_tooltipContainer__TP60i"};